import styled from "styled-components";

/* ── 페이지 컨테이너 ── */
export const PlanMainContainer = styled.div`
    width: 100%;
    padding-bottom: 40px;
    font-family: S-Core-Dream;

    .titleLb {
        color: #333;
        font-size: 24px;
        font-weight: 600;
    }

    .btnRow {
        display: flex;
        gap: 10px;
        padding: 0 12px;
        margin-bottom: 20px;
    }

    .addBtn {
        flex: 1;
        padding: 12px;
        background: #0d6efd;
        color: #fff;
        border: none;
        border-radius: 8px;
        font-size: 16px;
        font-family: S-Core-Dream;
        font-weight: 600;
        cursor: pointer;
        transition: background 0.2s;
        &:hover { background: #0b5ed7; }
        &:active { background: #0a58ca; }
    }

    .cancelBtn {
        width: 80px;
        padding: 12px;
        background: #fff;
        color: #495057;
        border: 1px solid #ced4da;
        border-radius: 8px;
        font-size: 16px;
        font-family: S-Core-Dream;
        font-weight: 600;
        cursor: pointer;
        transition: background 0.15s;
        &:hover { background: #e9ecef; }
    }

    .loadingMap {
        display: flex;
        position: fixed;
        top: 0; left: 0;
        align-items: center;
        height: 100%; width: 100%;
        z-index: 200;
        background: rgba(0,0,0,0.3);
        span {
            width: 100%;
            background: rgba(255,255,255,0.95);
            height: 80px;
            display: flex;
            justify-content: center;
            align-items: center;
            font-family: S-Core-Dream;
            font-weight: 600;
            font-size: 18px;
            color: #333;
        }
    }
`;

/* ── 폼 카드 ── */
export const FormCard = styled.div`
    background: #fff;
    border: 1px solid #dee2e6;
    border-radius: 12px;
    padding: 20px 16px;
    margin: 12px 12px 16px;
    box-shadow: 0 2px 8px rgba(0,0,0,0.06);
`;

/* ── 폼 그룹 (라벨 + input) ── */
export const FormGroup = styled.div`
    margin-bottom: 16px;

    label {
        display: block;
        font-size: 13px;
        font-weight: 600;
        color: #495057;
        margin-bottom: 6px;
    }

    input {
        width: 100%;
        height: 42px;
        padding: 0 12px;
        border: 1px solid #ced4da;
        border-radius: 8px;
        font-size: 14px;
        font-family: S-Core-Dream;
        background: #fff;
        box-sizing: border-box;
        outline: none;
        transition: border-color 0.2s, box-shadow 0.2s;
        &:focus {
            border-color: #86b7fe;
            box-shadow: 0 0 0 3px rgba(13,110,253,0.15);
        }
        &::placeholder { color: #adb5bd; }
    }
`;

/* ── 출발 / 도착 가로 배치 ── */
export const LocationRow = styled.div`
    display: flex;
    align-items: flex-start;
    gap: 8px;
    overflow: hidden;
`;

/* ── 출발 or 도착 블록 ── */
export const LocationBlock = styled.div`
    flex: 1;
    min-width: 0;

    label {
        display: block;
        font-size: 13px;
        font-weight: 600;
        color: #495057;
        margin-bottom: 6px;
    }

    input {
        width: 100%;
        height: 42px;
        padding: 0 12px;
        border: 1px solid #ced4da;
        border-radius: 8px;
        font-size: 14px;
        font-family: S-Core-Dream;
        background: #f8f9fa;
        box-sizing: border-box;
        cursor: pointer;
        outline: none;
        transition: border-color 0.2s;
        &:focus { border-color: #86b7fe; }
        &::placeholder { color: #adb5bd; }
    }
`;

/* ── 시간 선택 행 ── */
export const TimeRow = styled.div`
    display: flex;
    gap: 6px;
    margin-top: 8px;

    select {
        flex: 1;
        min-width: 0;
        height: 38px;
        padding: 0 4px;
        border: 1px solid #ced4da;
        border-radius: 8px;
        font-size: 13px;
        font-family: S-Core-Dream;
        background: #fff;
        color: #495057;
        outline: none;
        cursor: pointer;
        box-sizing: border-box;
        transition: border-color 0.2s;
        &:focus { border-color: #86b7fe; }
    }
`;

/* ── 출발↔도착 교환 버튼 ── */
export const SwapBtn = styled.button`
    align-self: center;
    margin-top: 20px;
    width: 36px;
    height: 36px;
    min-width: 36px;
    border: 1px solid #ced4da;
    border-radius: 50%;
    background: #fff;
    font-size: 18px;
    color: #495057;
    cursor: pointer;
    display: flex;
    align-items: center;
    justify-content: center;
    transition: background 0.2s, border-color 0.2s;
    &:hover {
        background: #e9ecef;
        border-color: #adb5bd;
    }
`;

/* ── 일정 리스트 아이템 ── */
export const PlanItem = styled.div`
    display: flex;
    align-items: center;
    background: #fff;
    border: 1px solid #dee2e6;
    border-radius: 10px;
    transition: border-color 0.15s, background 0.15s;

    &.editing {
        border-color: #0d6efd;
        background: #f0f6ff;
    }
    padding: 14px 16px;
    margin: 0 12px 10px;
    box-shadow: 0 1px 4px rgba(0,0,0,0.04);
    cursor: pointer;
    transition: background 0.15s, box-shadow 0.15s;

    &:hover {
        background: #f8f9fa;
        box-shadow: 0 2px 8px rgba(0,0,0,0.08);
    }

    .planContent {
        flex: 1;
        min-width: 0;
    }

    .planTitle {
        font-size: 15px;
        font-weight: 600;
        color: #212529;
        margin-bottom: 4px;
        white-space: nowrap;
        overflow: hidden;
        text-overflow: ellipsis;
    }

    .planMeta {
        font-size: 12px;
        color: #6c757d;
        white-space: nowrap;
        overflow: hidden;
        text-overflow: ellipsis;
    }

    .delBtn {
        width: 32px;
        height: 32px;
        min-width: 32px;
        border: 1px solid #dee2e6;
        border-radius: 8px;
        background: #fff;
        color: #dc3545;
        font-size: 18px;
        font-weight: 700;
        cursor: pointer;
        display: flex;
        align-items: center;
        justify-content: center;
        margin-left: 12px;
        transition: background 0.15s, border-color 0.15s;
        &:hover {
            background: #dc3545;
            color: #fff;
            border-color: #dc3545;
        }
    }
`;
